import {useEffect} from 'react';
import {useQuery} from '@tanstack/react-query';
import {
  FastAPIServiceError,
  Guidebook,
  PaginatedV2,
  QUERY_CACHE_KEYS,
  getFastAPIErrorMessage,
  filterVisibleGuidebooks,
} from '@chekin/core';
import {API} from '@chekin/api';
import {showToast} from '@chekinapp/ui';
import {useGuidebookLanguage} from './useGuidebookLanguage';

type Props = {
  reservationId: string;
};

function useFetchGuidebooks({reservationId}: Props) {
  const {language, isLanguageSupported} = useGuidebookLanguage();

  const query = useQuery<PaginatedV2<Guidebook>, FastAPIServiceError>({
    queryKey: [QUERY_CACHE_KEYS.guidebooks, reservationId, language],
    queryFn: () => API.guidebooks.getGuidebooks(reservationId),
    enabled: Boolean(reservationId) && isLanguageSupported,
    refetchOnWindowFocus: false,
    select: filterVisibleGuidebooks,
  });

  useEffect(() => {
    if (query.error) {
      showToast.error(getFastAPIErrorMessage(query.error));
    }
  }, [query.error]);

  return query;
}

export {useFetchGuidebooks};
